export default "__VITE_ASSET__f9b96297__"